import { render, staticRenderFns } from "./ChpcMenu.vue?vue&type=template&id=58926050&scoped=true&"
import script from "./ChpcMenu.vue?vue&type=script&lang=js&"
export * from "./ChpcMenu.vue?vue&type=script&lang=js&"
import style0 from "./ChpcMenu.vue?vue&type=style&index=0&id=58926050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58926050",
  null
  
)

export default component.exports